import { render, staticRenderFns } from "./OldResultsPage2023.vue?vue&type=template&id=17a24135"
import script from "./OldResultsPage2023.vue?vue&type=script&lang=js"
export * from "./OldResultsPage2023.vue?vue&type=script&lang=js"
import style0 from "./OldResultsPage2023.vue?vue&type=style&index=0&id=17a24135&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports